import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: process.env.VUE_APP_API_TIMEOUT,
});
instance.defaults.withCredentials = true;
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

instance.get(process.env.VUE_APP_API_COMMON_URL + '/sanctum/csrf-cookie').then(response => {
});

export default instance




